export default __webpack_public_path__ + "static/media/subquery.8b4df4b6.svg";